import addTargetEventListener from '../events/addTargetEventListener';
import { selectors } from './elements/constants';
import * as eventsModel from './models/events';
import * as actionModel from './models/action';
import compactObject from '../util/compactObject';
import getFieldValue from './elements/getFieldValue';
import getForm from './elements/getForm';
import getStep from './elements/getStep';
import replaceInterpolationTags from './text/replaceInterpolationTags';

const getTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

function buildUrl(url, params) {
  if (!params || Object.keys(params).length == 0) {
    return url;
  }

  return `${url}?${Object.entries(params)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v) || ''}`)
    .join('&')}`;
}

function thankYouRedirects(form, url, href) {
  switch (url) {
    case 'thank_you':
      return buildUrl('/contacts/marketing/thank-you', {
        correlation_id: getFieldValue(form, 'correlation_id'),
        phone_number: getFieldValue(form, 'phone_number'),
        time_zone: getTimezone()
      });
    case 'thank_you_nme':
      return buildUrl('/contacts/marketing/thank-you-nme', {
        correlation_id: getFieldValue(form, 'correlation_id'),
        phone_number: getFieldValue(form, 'phone_number'),
        time_zone: getTimezone()
      });
    case 'tutor_thank_you':
    case 'tutor_thank_you_cad': {
      const params = compactObject({
        interview_url: getFieldValue(form, 'interview_url')
      });

      const basePath = '/tutor-application/thank-you';
      const urlString = url === 'tutor_thank_you' ? basePath : `/en-ca${basePath}`;
      return buildUrl(urlString, params);
    }
  }
}

function getRedirectUrl(form, { url, href }) {
  if (url.includes('thank_you')) return thankYouRedirects(form, url, href);

  switch (url) {
    case 'custom':
      return replaceInterpolationTags(form, href || '');
    case 'home':
      return '/';
  }
}

/**
 * Handles `formWizard.showStep` events called on redirect action steps.
 * @param {Event} event - The current event being handled
 */
function handleShowStep(event) {
  const form = getForm(event.target);
  const step = getStep(event.target);

  if (!form || !step) {
    return;
  }

  if (actionModel.conditionsMet(step)) {
    window.location.href = getRedirectUrl(form, event.target.dataset);
  } else {
    // skip redirect and navigate if conditions are not met
    eventsModel.dispatchNavigateEvent(event.target);
  }
}

addTargetEventListener(
  eventsModel.events.showStep,
  selectors.actionRedirect,
  handleShowStep
);
